import React from 'react';
import { connect } from 'react-redux';
import * as css from 'styles';
import styled from 'react-emotion'

import { getVisibleData } from 'redux/models/projects'
import getRandomInt from 'utils/getRandomInt'
import shuffle from 'utils/shuffle'

import Text from 'components/Text/Text';
import View from 'components/View/View';
import Link from 'components/Link/Link';
import FadeIn from 'components/Animated/FadeIn'
import Loading from 'components/Loading/Loading';
import Img from 'components/Img/Img';

import Icon from './Icon';

const Project = styled(Link)({
  '& .img-hover': {
    transition: css.transition.xfast,
    border: `7px solid transparent`,
    '& img': {
      position: 'relative',
    }
  },
  '&:hover, &:active, &:focus': {
    outline: 'none',
    '& .img-hover': {
      borderColor: css.color.primary,
    }
  }
});

const ProjectIcon = styled('span')({
  [css.breakpoint.m_down]: {
    display: 'none !important',
  },
})

const ProjectsGrid = styled('div')({
  display: 'grid',
  gridColumnGap: '0.75rem',
  gridRowGap: '2rem',
  // gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gridTemplateColumns: 'repeat(8, 1fr)',
  gridAutoFlow: 'dense',

  [css.breakpoint.m_down]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  }
})

const ProjectsCell = styled('div')({

}, ({priority})=>{
  return {
    gridColumnEnd: `span ${priority}`,
    [css.breakpoint.m_down]: {
      // gridColumnEnd: `span ${priority < 3 ? 2 : 4}`,
    }
  }
})

// List of patterns that add up to 8 using 1,2,3,4 and must contain a single 4
const allPossiblePatterns = {
  primary: [
    [4, 3, 1],
    [4, 2, 2],
    [4, 2, 1, 1],
  ],
  secondary: [
    [3, 3, 2],
    [3, 3, 1, 1],
    [3, 2, 2, 1],
    [3, 2, 1, 1, 1],
  ],
  tertiary: [
    [2, 2, 2, 2],
    [2, 2, 2, 1, 1],
    [2, 2, 1, 1, 1, 1],
    [2, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1],
  ],
}

const patterns = [
  [4, 4],
  [4, 3, 1],
  [4, 2, 2],
  // [4, 2, 1, 1],
  [3, 3, 2],
  [3, 2, 2, 1],
]

// Pattern builder
const buildPattern = (rows) => {
  let pattern = []
  let last = -1

  function pickPattern(length) {
    let current;
    do { current = getRandomInt(0, length-1) } while (current === last)
    return (last = current);
  }

  // For every row, generate a new pattern and append it.
  for (let i = 0; i < rows; i++) {
    // Pick randomly from 'patterns', different from the last, then shuffle it
    // let patternIndex = pickPattern()
    // let subPattern = patterns[patternIndex]
    // let shuffled = shuffle(subPattern)
    let length = i < 2 ? 3 : patterns.length
    let subPattern = shuffle(patterns[pickPattern(length)])
    pattern = [...pattern, ...subPattern]
  }

  return pattern
}

const matchPattern = (pattern, items, key) => {
  var sortedArray = [];
  for (var i = 0; i < pattern.length; i++) {
    var found = false;
    for (var j = 0; j < items.length && !found; j++) {
      if (items[j][key] == pattern[i]) {
        sortedArray.push(items[j]);
        items.splice(j, 1);
        found = true;
      }
    }
  }
  return sortedArray
}

const simplePattern = (items, priority) => {
  return items
    .map(item => { 
      let i = item
      i.priority = priority // number from 1 to 4
      return i
    })
    .sort((a, b) => a.title.rendered.localeCompare(b.title.rendered))
}


const Projects = (props) => {

  // Testing data - change 'c' to props.data
  // const a = props.data
  // const b = [...a,...a,...a,...a]
  // const c = b.map(p => { p['priority'] = getRandomInt(1, 4); return p })
  
  // Assign priority from ACF or a fallback of 2
  const c = props.data.map(p => {
    p['priority'] = parseInt(p.acf.priority) || 2; // || getRandomInt(1, 4); 
  return p })

  // Build and match the pattern for the grid layout
  const pattern = buildPattern(72)
  const projects = props.location.includes('category') ? simplePattern(c, 2) : matchPattern(pattern,c,'priority')
  // console.log('compare:', pattern, projects.map((a)=>a.priority))

  window.scrollTo(0, 0)
  
  return (
  <Loading
    status={props.status}
    errormessage="Projects could not be loaded, try refreshing."
    height="80vh"
  >

  <ProjectsGrid>
    {projects.map((project,i)=>{
      // const imageIndex = project.acf && getRandomInt(0, project.acf.images.length-1)
      // const image = project.acf && project.acf.images && project.acf.images[imageIndex];
      const cover_image = project.acf && project.acf.cover_image
      const first_image = project.acf && project.acf.images && project.acf.images[0]
      const image = cover_image || first_image.image
      return (
        <ProjectsCell key={project.slug + i} priority={project.priority}>
        <Project to={`/projects/${project.slug}`}>
            {image && (cover_image || first_image) && (
              <Img
                nospinner
                noloading
                overlay
                src={image.sizes.medium_large}
                width={image.width}
                height={image.height}
              />
            )}
            <Text type="h4" style={{ marginTop: css.space.xxs,}}>
              <ProjectIcon><Icon type="circle" style={{ marginRight: '0.5em' }} /></ProjectIcon>
              <span dangerouslySetInnerHTML={{ __html:project.title.rendered}}/>
            </Text>
        </Project>
      </ProjectsCell>
    )})}

  </ProjectsGrid>
  </Loading>
  )
};

const mapState = state => ({
  data: getVisibleData(state.projects),
  status: state.projects.status,
  error: state.projects.error,
  query: state.projects.query,
  location: state.location.type,
})

export default connect(mapState)(Projects);



// WEBPACK FOOTER //
// ./src/containers/Projects.js